module.exports = __webpack_public_path__ + "img/arrow.c221c897.png";